import { api } from "../api";

/**
 * generateTokenByUser - Function that generate a token to access user account by manager
 * /users/token 
 * method POST 
 * @async-function
 */
const generateTokenByUser = async (token: string, email: string, userId: number) => {
  const response = await api.post(
    "/users/token", { email: email, userId: userId },{
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
  return response;
};

export default generateTokenByUser;
